import {
  StringParam,
  ArrayParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';

const searchParamsDef = {
  selectedScores: withDefault(ArrayParam, ['A', 'B', 'C', 'D']),
  startDate: StringParam,
  endDate: StringParam,
  assignee: StringParam,
  direction: StringParam,
};

const useSearchParams = () => {
  const [query, setQuery] = useQueryParams(searchParamsDef);

  const searchParams = {
    selectedScores: query.selectedScores,
    startDate: query.startDate,
    endDate: query.endDate,
    assignee: query.assignee,
    direction: query.direction,
  };

  return {
    query,
    setQuery,
    searchParams,
  };
};

export default useSearchParams;
